module.exports = __webpack_public_path__ + "img/list-pattern2.4e75da5.svg";